import { TicketDetailView as SdkTicketDetailView } from '@reqdesk/sdk-react'

interface TicketDetailViewProps {
  ticketId: string
  onBack: () => void
}

export function TicketDetailView({ ticketId, onBack }: TicketDetailViewProps) {
  return <SdkTicketDetailView ticketId={ticketId} onBack={onBack} />
}
